module.exports = __webpack_public_path__ + "static/img/7.bdf86ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/7.png
// module id = smV2
// module chunks = 0